/* eslint-disable react/default-props-match-prop-types */
import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Box,
} from "@mui/material";

type NoteDlgProps = {
  open: boolean;
  contentText: string;
  bComment: boolean;
  handleNo?: () => void;
  handleYes?: (str: string) => void;
  handleOK?: () => void;
};

const NoteDlg = ({
  open,
  contentText,
  bComment,
  handleNo,
  handleYes,
  handleOK,
}: NoteDlgProps) => {
  const [_d, set_D] = useState<string>("");

  const handleBtnYes = () => {
    if (handleYes) handleYes(_d);
  };

  const handleBtnNo = () => {
    if (handleNo) {
      set_D("");
      handleNo();
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "y" || event.key === "Enter") {
      if (handleBtnYes) handleBtnYes();
    } else if (event.key === "n" || event.key === "Escape") {
      handleBtnNo();
    }
  };

  return (
    <Dialog open={open} onKeyDown={handleKeyDown}>
      <DialogContent>
        <Box
          component="div"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            width: "350px",
            mt: "24px",
            ml: "24px",
            mr: "24px",
          }}
        >
          <DialogContentText fontSize="22px" fontWeight={400}>
            {contentText}
          </DialogContentText>
        </Box>
      </DialogContent>
      <Box
        sx={{
          mb: "24px",
          mr: "24px",
        }}
      >
        <DialogActions>
          {handleNo && (
            <Button onClick={handleBtnNo}>
              {" "}
              <b>
                <u>N</u>
              </b>
              O
            </Button>
          )}
          {handleYes && (
            <Button
              onClick={handleBtnYes}
              disabled={
                bComment === false ? false : _d.length >= 10 ? false : true
              }
            >
              <b>
                <u>Y</u>
              </b>
              ES
            </Button>
          )}
          {handleOK && <Button onClick={handleOK}>OK</Button>}
        </DialogActions>
      </Box>
    </Dialog>
  );
};

NoteDlg.defaultProps = {
  open: false,
  contentText: "",
  bComment: false,
};

export default NoteDlg;
